import {AccordionItem, Text, Icon, Tag} from '@/components-v2'
import {OrderChangeTag} from './OrderChangeTag'
import {OrderPositionInput} from './OrderPositionInput'
import {SubcategoryItem} from './SubcategoryItem'
import {useCatalogSortable} from '../hooks/useCatalogSortable'
import {
  getCatalogItemName,
  getHiddenSubcategoriesCount,
  getOrderItemKey,
} from '@/containers/Content/ProductCatalog/utils/productCatalogUtils'

export const CategoryItem = ({
  category,
  index,
  totalCategories,
  expanded,
  onToggleExpanded,
  onToggleSubcategoryVisibility,
  isEditMode,
  disabled,
  moveItem,
  getOriginalPosition,
  directlyMoved,
  onInputStateChange,
  destination,
}) => {
  const {ref, handleRef, isDragging} = useCatalogSortable({
    id: category.id,
    index,
    disabled: !isEditMode || disabled,
  })
  const subcategories = category.subCategories ?? []
  const categoryName = getCatalogItemName(category)
  const itemKey = getOrderItemKey(category.id)
  const originalPosition = getOriginalPosition(category.id)
  const insertion = destination?.parentId === null && destination.id === category.id ? destination.edge : undefined

  return (
    <div ref={ref} className={`catalog-order-row ${isDragging ? 'opacity-50' : ''}`} data-insertion={insertion}>
      <AccordionItem
        presentation="border"
        expanded={expanded}
        onUpdate={onToggleExpanded}
        label={
          <div className="flex items-center gap-4">
            <button
              type="button"
              ref={handleRef}
              hidden={!isEditMode}
              className="cursor-grab touch-none"
              disabled={!isEditMode || disabled}
              onClick={event => event.stopPropagation()}
              onKeyDown={event => event.stopPropagation()}
            >
              <Icon icon="drag_indicator" size="small" />
            </button>
            {isEditMode ? (
              <OrderPositionInput
                itemKey={itemKey}
                position={index + 1}
                maxPosition={totalCategories}
                disabled={disabled}
                onCommit={position => moveItem(category.id, position)}
                onInputStateChange={onInputStateChange}
              />
            ) : (
              <Text className="font-semibold">{index + 1}.</Text>
            )}
            <Text>{categoryName}</Text>
          </div>
        }
        rightAccessoryChild={
          isEditMode ? (
            directlyMoved.has(itemKey) && (
              <OrderChangeTag
                originalPosition={originalPosition}
                position={index + 1}
                disabled={disabled}
                onUndo={() => moveItem(category.id, originalPosition)}
              />
            )
          ) : (
            <Tag
              text={`${getHiddenSubcategoriesCount(subcategories)} hidden`}
              color="gray"
              type="default"
              iconLeading="visibility_off"
            />
          )
        }
      >
        {expanded && (
          <div data-catalog-list className="flex w-full flex-col gap-3 p-6">
            {subcategories.map((subcategory, subIndex) => (
              <SubcategoryItem
                key={subcategory.id}
                subcategory={subcategory}
                parentId={category.id}
                index={subIndex}
                totalSubcategories={subcategories.length}
                onToggleVisibility={() => onToggleSubcategoryVisibility(category.id, subcategory.id)}
                isEditMode={isEditMode}
                disabled={disabled}
                moveItem={moveItem}
                getOriginalPosition={getOriginalPosition}
                directlyMoved={directlyMoved}
                onInputStateChange={onInputStateChange}
                destination={destination}
              />
            ))}
          </div>
        )}
      </AccordionItem>
    </div>
  )
}
